import { AITrace } from "../models/aiTrace";
import axiosConfig from "./axiosConfig";

// Fetch the complete AI trace from a people-discovery run. Returns null when no
// trace is available. `subjectRef` is the fully-composed storage ref: the real path
// is "<leadId>:<role>", the test path is the result's traceSubjectRef verbatim.
// `runId` is required and read off the persisted role blob
// (`contactCandidates[role].traceRunId`) - there is no "latest for this subject"
// fallback, so the caller only invokes this once a run_id exists.
const getPeopleDiscoveryTrace = async (
  authToken: string,
  subjectRef: string,
  runId: string
): Promise<AITrace | null> => {
  const { data } = await axiosConfig.get(`/leads/people-discovery-trace`, {
    params: { subjectRef, runId },
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data?.trace ?? null;
};

export default getPeopleDiscoveryTrace;
